import { render, staticRenderFns } from "./DadosBoletimSanitario.vue?vue&type=template&id=6222065b&scoped=true&"
import script from "./DadosBoletimSanitario.vue?vue&type=script&lang=js&"
export * from "./DadosBoletimSanitario.vue?vue&type=script&lang=js&"
import style0 from "./DadosBoletimSanitario.vue?vue&type=style&index=0&id=6222065b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6222065b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VAutocomplete,VCol,VDataTable,VIcon,VRow,VSelect,VSimpleCheckbox})
